export default __webpack_public_path__ + "static/media/Ophidian Band.bfc91227.jpg";